<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="
                  isDeletePage() != true
                    ? 'Pet Trainer Applications'
                    : 'Deleted Trainer Applications'
                "
              ></h3>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    color="#e60040"
                    hide-details="auto"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    hide-details="auto"
                    rounded
                    @click:clear="(filter.is_active = null), (page = 1)"
                    v-model="filter.is_active"
                    :items="statuses"
                    label="Status"
                    @input="(page = 1), getData()"
                    placeholder="Filter by Active Status"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section v-if="isLoading" style="height: 575px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="575"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left sr_no">Sr No</th>
                      <th class="text-left">Status</th>
                      <th class="text-left" style="min-width: none">
                        Full Name
                      </th>
                      <th class="text-left" style="min-width: none">
                        Date Of Birth
                      </th>
                      <th class="text-left" style="min-width: none">
                        Phone No
                      </th>
                      <th class="text-left" style="min-width: none">Email</th>
                      <th class="text-left" style="min-width: none">Address</th>
                      <th class="text-left" style="min-width: none">Pincode</th>
                      <th class="text-left" style="min-width: none">
                        Preferred Timeslot
                      </th>
                      <th class="text-left" style="min-width: none">Gender</th>
                      <th class="text-left" style="min-width: none">
                        Is Experienced
                      </th>
                      <th class="text-left" style="min-width: none">
                        Experienced Details
                      </th>
                      <th class="text-left" style="min-width: none">
                        Animal Trained
                      </th>
                      <th class="text-left" style="min-width: none">
                        Animal Description
                      </th>
                      <th class="text-left" style="min-width: none">
                        Language Spoken
                      </th>
                      <th class="text-left" style="min-width: none">
                        Other Language Spoken
                      </th>
                      <th class="text-left" style="min-width: 160px">
                        Created At
                      </th>
                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="pet_trainer_career_requests.length != 0">
                    <tr
                      v-for="(
                        pet_trainer_career_request, i
                      ) in pet_trainer_career_requests"
                      :key="`pet_trainer_career_request_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last':
                          pet_trainer_career_requests.length - 1 == i,
                      }"
                    >
                      <td style="min-width: 85px">
                        {{ i + 1 }}
                      </td>
                      <td>
                        <v-chip
                          small
                          :color="
                            pet_trainer_career_request.status == 1
                              ? 'teal'
                              : pet_trainer_career_request.status == 2
                              ? 'red'
                              : 'yellow'
                          "
                          :text-color="
                            pet_trainer_career_request.status == 0
                              ? 'black'
                              : 'white'
                          "
                        >
                          {{
                            pet_trainer_career_request.status == 1
                              ? "Approved"
                              : pet_trainer_career_request.status == 2
                              ? "Rejected"
                              : "Pending"
                          }}
                        </v-chip>
                      </td>
                      <td>{{ pet_trainer_career_request.user_name || "" }}</td>
                      <td>{{ pet_trainer_career_request.dob || "" }}</td>
                      <td>{{ pet_trainer_career_request.phone_no || "" }}</td>
                      <td>{{ pet_trainer_career_request.email || "" }}</td>
                      <td>{{ pet_trainer_career_request.address || "" }}</td>
                      <td>{{ pet_trainer_career_request.pin_code || "" }}</td>
                      <td>
                        {{
                          pet_trainer_career_request.preferred_timeslot || ""
                        }}
                      </td>
                      <td>
                        {{
                          pet_trainer_career_request.gender === 0
                            ? "Male"
                            : pet_trainer_career_request.gender === 1
                            ? "Female"
                            : pet_trainer_career_request.gender === 2
                            ? "Other"
                            : ""
                        }}
                      </td>
                      <td>
                        {{ pet_trainer_career_request.is_experienced ? "YES" : "NO" }}
                      </td>
                      <td style="max-width: 260px">
                        <div
                          v-if="pet_trainer_career_request.experience_description"
                          class="text-clamp"
                          @click="
                            showFullText(
                              pet_trainer_career_request.experience_description
                            )
                          "
                        >
                          {{ pet_trainer_career_request.experience_description }}
                        </div>
                      </td>
                      <td>
                        {{
                          pet_trainer_career_request.trained_animal_type || ""
                        }}
                      </td>
                      <td style="max-width: 260px">
                        <div
                          v-if="
                            pet_trainer_career_request.trained_animal_description
                          "
                          class="text-clamp"
                          @click="
                            showFullText(
                              pet_trainer_career_request.trained_animal_description
                            )
                          "
                        >
                          {{
                            pet_trainer_career_request.trained_animal_description
                          }}
                        </div>
                      </td>
                      <td>
                        {{ pet_trainer_career_request.language_spoken || "" }}
                      </td>
                      <td>
                        {{
                          pet_trainer_career_request.other_language_spoken ||
                          ""
                        }}
                      </td>
                      <td style="min-width: 160px">
                        {{ formatDate(pet_trainer_career_request.created_at) }}
                      </td>
                      <td class="text-right">
                        <v-btn v-can:edit="'pet_trainer_requests'"
                          v-if="pet_trainer_career_request.status === 0"
                          class="ml-2"
                          x-small
                          fab
                          color="success"
                          @click="
                            updateStatus(pet_trainer_career_request.id, 1)
                          "
                        >
                          <v-icon dark>mdi-check</v-icon>
                        </v-btn>

                        <!-- Reject button (only show if status is 0) -->
                        <v-btn v-can:edit="'pet_trainer_requests'"
                          v-if="pet_trainer_career_request.status === 0"
                          class="ml-2"
                          x-small
                          fab
                          color="error"
                          @click="
                            updateStatus(pet_trainer_career_request.id, 2)
                          "
                        >
                          <v-icon dark>mdi-close</v-icon>
                        </v-btn>
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-can:delete="'pet_trainer_requests'"
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="
                                  OpenWarning(pet_trainer_career_request.id)
                                "
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this PetTrainerCareerRequest</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="primary"
                                :to="`/pet-trainer-career-requests/${encryptIt(
                                  pet_trainer_career_request.id
                                )}`"
                              >
                                <v-icon dark> mdi-pencil </v-icon>
                              </v-btn>
                            </template>
                            <span>Edit this PetTrainerCareerRequest</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-can:delete="'pet_trainer_requests'"
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="
                                  Restore_this(pet_trainer_career_request.id)
                                "
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this pet_trainer_career_request</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="100" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination rounded v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_deleted_pet_trainer_career_request" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>PetTrainerCareerRequest deleted successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_deleted_pet_trainer_career_request = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_restored_pet_trainer_career_request" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>PetTrainerCareerRequest restored successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_restored_pet_trainer_career_request = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>

      <v-dialog v-model="textDialog" max-width="600">
        <v-card>
          <v-card-title class="text-h6">Details</v-card-title>
          <v-card-text style="white-space: pre-wrap">{{
            textDialogContent
          }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="textDialog = false"
              >Close</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Status Change Warning Dialog Box -->
      <v-dialog v-model="show_Warning_popUp" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-alert
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Warning!</h1>
                      <br />
                      <h3>
                        Are you sure to
                        {{
                          selected_requested.status == "1"
                            ? "Approve"
                            : "Reject"
                        }}?.
                      </h3>
                      <br />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-btn v-can:edit="'pet_trainer_requests'"
                        color="success"
                        @click="
                          (show_Warning_popUp = false),
                            confirmUpdate(selected_requested)
                        "
                      >
                        Confirm
                      </v-btn>
                    </v-col>
                    <v-col>
                      <v-btn
                        color="red"
                        dark
                        @click="
                          (show_Warning_popUp = false),
                            (selected_requested = {})
                        "
                      >
                        Cancel
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Delete Warning Dialog Box -->
      <v-dialog v-model="deleteDialog" width="550px">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 150px"
                >
                  mdi-delete-alert
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Warning!</h1>
                      <br />
                      <h3>Are you sure you want to delete this?</h3>
                      <br />
                      <v-btn color="grey" dark @click="deleteDialog = false"
                        >Cancel</v-btn
                      >
                      <v-btn
                        color="red"
                        dark
                        class="ml-5"
                        @click="
                          Delete_this(to_be_deleted_id), (deleteDialog = false)
                        "
                        >Delete</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "PetTrainerCareerRequestsPage",
  data() {
    return {
      textDialog: false,
      textDialogContent: "",
      filter: {
        search_keyword: "",
        is_active: "",
        show_deleted: false,
      },
      pet_trainer_career_requests: [],
      statuses: [
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      ExportPetTrainerCareerRequestTypes: [],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      excel_fields: {
        "Sr No": "sr_no",
        Name: "name",
      },
      isLoading: false,
      isExcelloading: false,
      show_Warning_popUp: false,
      selected_requested: {},
      deleteDialog: false,
      to_be_deleted_id: "",
      delete_pet_trainer_career_request: false,
      is_deleted_pet_trainer_career_request: false,
      restore_pet_trainer_career_request: false,
      is_restored_pet_trainer_career_request: false,
    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    formatDate(value) {
      if (!value) return "";
      try {
        const d = new Date(value);
        const pad = (n) => String(n).padStart(2, "0");
        const day = pad(d.getDate());
        const month = pad(d.getMonth() + 1);
        const year = d.getFullYear();
        const hours = pad(d.getHours());
        const minutes = pad(d.getMinutes());
        const seconds = pad(d.getSeconds());
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
      } catch (e) {
        return value;
      }
    },
    showFullText(text) {
      this.textDialogContent = text;
      this.textDialog = true;
    },
    OpenWarning(request_id) {
      this.to_be_deleted_id = request_id;
      this.deleteDialog = true;
    },
    updateStatus(id, status) {
      this.selected_requested = {
        id: id,
        status: status,
      };
      this.show_Warning_popUp = true;
    },
    async confirmUpdate(selected_requested) {
      let reqID = this.encryptIt(selected_requested.id);

      await axios
        .patch(`/pet_trainer_career_requests/${reqID}`, selected_requested)
        .then(() => {
          this.getData();
        });
      this.show_Warning_popUp = false;
    },
    async getData() {
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&show_deleted=" +
        this.filter.show_deleted +
        "&is_active=" +
        this.filter.is_active +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`pet_trainer_career_requests?${query}`)
        .then((response) => {
          this.pet_trainer_career_requests = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
      this.isLoading = false;
    },
    //Generate Excel
    async generateExcel() {
      let query = "search_keyword=" + this.filter.search_keyword;
      let response = await axios.get(
        `pet_trainer_career_request_exports?${query}`
      );
      console.log(response.data.data);
      if (response) {
        window.open(`${response.data.data}`, "_blank");
      }
    },
    async Delete_this(id) {
      this.delete_pet_trainer_career_request = true;
      await axios
        .post(`/pet_trainer_career_requests/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.delete_pet_trainer_career_request = false;
          this.is_deleted_pet_trainer_career_request = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },
    async Restore_this(id) {
      this.restore_pet_trainer_career_request = true;
      await axios
        .post(`/pet_trainer_career_requests/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.restore_pet_trainer_career_request = false;
          this.is_restored_pet_trainer_career_request = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },
  },
};
</script>

<style scoped>
.text-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  cursor: pointer;
  max-width: 260px;
}
</style>
